import { ErrorBoundary as SentryErrorBoundary } from '@sentry/react';
import { ErrorFallback } from './ErrorFallback';

interface Props {
    children: React.ReactNode,
    fallback?: React.ReactNode
}

export const ErrorBoundary = ({ children, fallback }: Props): React.ReactElement<any, any> => {
    return (
        <SentryErrorBoundary fallback={fallback ? <>{fallback}</> : ErrorFallback}>
            {children}
        </SentryErrorBoundary>
    );
};
